import { render, staticRenderFns } from "./DashboardBreadcrumb.vue?vue&type=template&id=4f5dc1e6"
import script from "./DashboardBreadcrumb.vue?vue&type=script&lang=js"
export * from "./DashboardBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./DashboardBreadcrumb.vue?vue&type=style&index=0&id=4f5dc1e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports